import { render, staticRenderFns } from "./SidePanel.vue?vue&type=template&id=18d50e81&scoped=true"
import script from "./SidePanel.vue?vue&type=script&lang=js"
export * from "./SidePanel.vue?vue&type=script&lang=js"
import style0 from "./SidePanel.vue?vue&type=style&index=0&id=18d50e81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d50e81",
  null
  
)

export default component.exports